export default {
  'message.error-message.title': 'Something went wrong!',
  'message.success-message.title': 'Success!',
};
